import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { auth } from './components/Recipe/Firebase/InitialiseFirebase';
import { ToastProvider } from './design/components';
import LegalItems from './components/Legal/LegalItems';
import Showcase from './components/Showcase/Showcase';
import Library from './components/Library/Library';
import PreLogin from './components/Landing/PreLogin';
import CookMode from './components/Cook/CookMode';
import ShareRecipe from './components/Share/ShareRecipe';
import SignInScreen from './components/Auth/SignInScreen';

const Home: React.FC<{ userId: string | null; userName: string | null }> = ({
  userId,
  userName,
}) => {
  if (!userId) return <PreLogin />;
  return <Library userId={userId} userName={userName} />;
};

export default function App() {
  const [user, setUser] = useState<User | null>(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (nextUser) => {
      setUser(nextUser);
      setAuthReady(true);
    });
    return unsubscribe;
  }, []);

  if (!authReady) return null;
  const userId = user?.uid ?? null;
  const userName = user?.displayName ?? null;

  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home userId={userId} userName={userName} />} />
          <Route path="/cook/:recipeId" element={<CookMode />} />
          <Route path="/r/:shareToken" element={<ShareRecipe />} />
          <Route path="/signin" element={<SignInScreen />} />
          <Route path="/privacy-and-terms" element={<LegalItems />} />
          <Route path="/showcase" element={<Showcase />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}
